import type { View } from "../router";
import { currentUser } from "../session";
import { loadSprites, spriteHtml } from "../sprites";
import { t } from "../i18n";
import { langSelect } from "../ui";

export const titleView: View = (root) => {
  const next = currentUser() ? "#/menu" : "#/entrar";
  root.innerHTML = `
    <main class="shell-center">
      <div class="title-lang">${langSelect()}</div>
      <img class="brand-logo" src="/icons/logo-256.png" width="128" height="128" alt="">
      <p class="shell-logo">PokéChess</p>
      <div class="title-mons" data-mons></div>
      <p class="bw-subtitle">${t("title.set")}</p>
      <a class="bw-btn bw-btn--blue" href="${next}" style="min-width:220px">${t("title.start")}</a>
      <p class="bw-dim shell-blink">${t("title.tap")}</p>
      <a class="bw-dim small" href="#/creditos">${t("title.credits")}</a>
    </main>`;
  void loadSprites().then(() => {
    root.querySelector("[data-mons]")!.innerHTML = [25, 6, 9, 3].map((s) => spriteHtml(s, 72)).join("");
  });
};
